export const UPDATE_ITEMS_PER_PAGE = 'UPDATE_ITEMS_PER_PAGE';
export const CLEAR_ITEMS_PER_PAGE = 'CLEAR_ITEMS_PER_PAGE';
export const CLEAR_CENTRALIZED_ISSUES_PAGINATION_STATE = 'CLEAR_CENTRALIZED_ISSUES_PAGINATION_STATE';
export const CLEAR_INTEGRATIONS_PAGINATION_STATE = 'CLEAR_INTEGRATIONS_PAGINATION_STATE';
export const CLEAR_HIGHLIGHT_REPORTS_PAGINATION_STATE = 'CLEAR_HIGHLIGHT_REPORTS_PAGINATION_STATE';
export const CLEAR_SERVICES_ASSETS_PAGINATION_STATE = 'CLEAR_SERVICES_ASSETS_PAGINATION_STATE';
export const CLEAR_INFOSTEALERS_PAGINATION_STATE = 'CLEAR_INFOSTEALERS_PAGINATION_STATE';
